import type { App } from 'vue'

export function registerGlobComp(app: App) {
  // Arco Design components are auto-imported via unplugin-vue-components in vite.config.js
}
